import React from 'react';

import cn from 'classnames';

import ButtonBase, { ButtonBaseProps } from './ButtonBase';

interface SolidButtonProps
  extends Omit<ButtonBaseProps, 'className' | 'style'> {
  variant: 'primary' | 'danger';
  isProtected?: boolean;
}

export const mapSolidVariant = {
  primary: `sp-btn-action`,
  danger: `sp-btn-action-solid-danger`,
};

const SolidButton = ({
  variant,
  children,
  isProtected,
  ...restProps
}: SolidButtonProps) => {
  return (
    <ButtonBase
      {...restProps}
      className={cn('shadow-xs border', mapSolidVariant[variant])}
      protectedVariant={isProtected ? 'solid' : undefined}
    >
      {children}
    </ButtonBase>
  );
};

export default SolidButton;
